import algoliasearch, { SearchClient } from "algoliasearch";

import {
    performAlgoliaTextSearch,
    FirestoreTextSearchController
} from "@camberi/firecms";

let client: SearchClient | undefined = undefined;

//sandbox
if ((window.location.href.includes('sandbox') || window.location.href.includes('test') || window.location.href.includes('localhost'))) {
    if (process.env.REACT_APP_ALGOLIA_APP_ID_SANDBOX && process.env.REACT_APP_ALGOLIA_SEARCH_KEY_SANDBOX) {
        client = algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID_SANDBOX, process.env.REACT_APP_ALGOLIA_SEARCH_KEY_SANDBOX);
    } else {
        console.error("REACT_APP_ALGOLIA_APP_ID_SANDBOX or REACT_APP_ALGOLIA_SEARCH_KEY_SANDBOX env variables not specified");
        console.error("Text search not enabled");
    }
} else {//live
    if (process.env.REACT_APP_ALGOLIA_APP_ID_LIVE && process.env.REACT_APP_ALGOLIA_SEARCH_KEY_LIVE) {
        client = algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID_LIVE, process.env.REACT_APP_ALGOLIA_SEARCH_KEY_LIVE);
    } else {
        console.error("REACT_APP_ALGOLIA_APP_ID_LIVE or REACT_APP_ALGOLIA_SEARCH_KEY_LIVE env variables not specified");
        console.error("Text search not enabled");
    }
}


const productsIndex = client && client.initIndex("products");
const usersIndex = client && client.initIndex("users");
const blogIndex = client && client.initIndex("blogs");
const recipesIndex = client && client.initIndex("recipes");
const sessionIndex = client && client.initIndex("sessions");
const videoUploadsIndex = client && client.initIndex("video_uploads");
const mediaIndex = client && client.initIndex("media");
const linkIndex = client && client.initIndex("links");
const staticPagesIndex = client && client.initIndex("static_pages");
const coachesIndex = client && client.initIndex("coaches");
const workoutCategoriesIndex = client && client.initIndex("workout_categories");
const videoCategoriesIndex = client && client.initIndex("video_categories");

const questionsIndex = client && client.initIndex("questions");
const onboardingIndex = client && client.initIndex("onboarding");
const generalSettingsIndex = client && client.initIndex("general_settings");
const customColorIndex = client && client.initIndex("custom_color");
const feedbackQuestionIndex = client && client.initIndex("feedback_questions");
const programsIndex = client && client.initIndex("programs");

export const textSearchController: FirestoreTextSearchController =
    ({ path, searchString }) => {
        if (path === "products")
            return productsIndex && performAlgoliaTextSearch(productsIndex, searchString);
        if (path === "users")
            return usersIndex && performAlgoliaTextSearch(usersIndex, searchString);
        if (path === "blogs")
            return blogIndex && performAlgoliaTextSearch(blogIndex, searchString);
        if (path === "recipes")
            return recipesIndex && performAlgoliaTextSearch(recipesIndex, searchString);
        if (path === "sessions")
            return sessionIndex && performAlgoliaTextSearch(sessionIndex, searchString);
        if (path === "video_uploads")
            return videoUploadsIndex && performAlgoliaTextSearch(videoUploadsIndex, searchString);
        if (path === "media")
            return mediaIndex && performAlgoliaTextSearch(mediaIndex, searchString);
        if (path === "links")
            return linkIndex && performAlgoliaTextSearch(linkIndex, searchString);
        if (path === "static_pages")
            return staticPagesIndex && performAlgoliaTextSearch(staticPagesIndex, searchString);
        if (path === "coaches")
            return coachesIndex && performAlgoliaTextSearch(coachesIndex, searchString);
        if (path === "workout_categories")
            return workoutCategoriesIndex && performAlgoliaTextSearch(workoutCategoriesIndex, searchString);
        if (path === "video_categories")
            return videoCategoriesIndex && performAlgoliaTextSearch(videoCategoriesIndex, searchString);
        if (path === "questions")
            return questionsIndex && performAlgoliaTextSearch(questionsIndex, searchString);
        if (path === "onboarding")
            return onboardingIndex && performAlgoliaTextSearch(onboardingIndex, searchString);
        if (path === "general_settings")
            return generalSettingsIndex && performAlgoliaTextSearch(generalSettingsIndex, searchString);
        if (path === "custom_color")
            return customColorIndex && performAlgoliaTextSearch(customColorIndex, searchString);
        if (path === "feedback_questions")
            return feedbackQuestionIndex && performAlgoliaTextSearch(feedbackQuestionIndex, searchString);
        if (path === "programs")
            return programsIndex && performAlgoliaTextSearch(programsIndex, searchString);
        return undefined;
    };
